import React from 'react'
import { useIsDesktop } from '../../../../hooks/index';
import { track } from '../../../../shared/analytics';
import './AboutTheGame.scss';

const AboutTheGame = () => {
    const isDesktop = useIsDesktop();

    return (
        <div className="about-the-game-component">
            <div className="about-the-game-component__container">
                <h2>ABOUT THE GAME</h2>

                <p>
                    Play COTI’s NFT Game, collect unique NFTs, and win insane COTI prizes worth over 2,000,000 $COTI!
                </p> 

                <p>
                    The COTI NFT game will be played for 4 seasons: Spring, Summer, Winter, and Fall - each season consists of 4 weeks. 
                    Players holding Native $COTI in their VIPER wallet will be able to make a claim and participate in an NFT drop every week. 
                </p>
                
                <h2 className="prizes">Prizes</h2>

                <p>
                    Collect 1 CommonNFT to win 1,000 $COTI immediately each week
                </p>

                <p>
                    Collect all 3 viper NFTs to participate in a seasonal raffle to have the chance to win 52,000 COTI, spread into weekly settlements of 1,000 COTI for a full year!
                </p>

                <p>
                    Collect all 4 Legendary NFTs to participate in a final game raffle to have a chance to win 1,000,000 $COTI!
                </p>

                <p>
                    Cooperation is key in order to collect the winning NFT combinations. You can trade, buy and sell the COTI NFTs through our NFT partner platform SuperFarm.
                </p>

                <p>Sounds awesome, right? Check our <a href="https://cotinetwork.medium.com/coti-will-launch-an-nft-game-with-insane-coti-prizes-of-over-2-000-000-coti-57f6d6acd0ef" target="_blank" rel="noopener noreferrer" onClick={() => track("about the game - game guide")}>Game Guide</a> for more details </p>
            </div>

            {isDesktop ? 
                <img src={require('../../../../images/layout/stripe-middle.svg').default} alt="stripe" /> : 
                <img src={require('../../../../images/layout/stripe-middle-mobile.svg').default} alt="stripe" /> }
        </div>
    )
}


export default AboutTheGame;